import {
  takeEvery, all, call, put, select,
} from 'redux-saga/effects';

import { notification } from '@anna/anna-ws-ui';

import {
  apiGetChangeRequests,
  apiSendChangeRequests,
} from './api';

import {
  getChangeRequestRequest,
  getChangeRequestSuccess,
  getChangeRequestError,
  getChangeRequestActionTypes,
  sendChangeRequestRequest,
  sendChangeRequestSuccess,
  sendChangeRequestError,
  sendChangeRequestActionTypes,

} from './actions';

function getNormalizedRequests(items) {
  const data = {
    expenseType: {},
    receipt: {},
  };

  items.forEach((transaction) => {
    if (transaction.request_type === 'receipt') {
      data.receipt[transaction.transaction_id] = transaction;
    } else if (transaction.request_type === 'expense_type') {
      data.expenseType[transaction.transaction_id] = transaction;
    }
  });
  return data;
}

function* fetchChangeRequests() {
  try {
    yield put(getChangeRequestRequest());
    const companyId = yield select((state) => state.appService.companyId);
    const response = yield call(() => apiGetChangeRequests(companyId));
    const responseJson = yield response.json();

    const changeRequests = getNormalizedRequests(responseJson.data.items);

    yield put(getChangeRequestSuccess({
      ...changeRequests,
    }));
  } catch (error) {
    console.error(error);
    yield put(getChangeRequestError(error));
  }
}

function* putChangeRequests({ transactionId, requestType }) {
  try {
    yield put(sendChangeRequestRequest());

    const { customer, account } = yield select((state) => state.accountService);
    const companyId = yield select((state) => state.appService.companyId);

    const response = yield call(
      () => apiSendChangeRequests(
        companyId,
        customer.magnetaAlias,
        account.id,
        transactionId,
        requestType,
      ),
    );
    const responseJson = yield response.json();

    const data = getNormalizedRequests(responseJson.data.items);

    yield put(sendChangeRequestSuccess({
      ...data,
    }));

    notification.info(`Request for ${customer.full_name} transaction has been sent`);
  } catch (error) {
    console.error(error);
    yield put(sendChangeRequestError(error));
  }
}

function* watchSagas() {
  yield takeEvery(getChangeRequestActionTypes.common, fetchChangeRequests);
  yield takeEvery(sendChangeRequestActionTypes.common, putChangeRequests);
}

export default function* root() {
  yield all([
    watchSagas(),
  ]);
}
